import script from "./scenicStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./scenicStatistics.vue?vue&type=script&setup=true&lang=js"

import "./scenicStatistics.vue?vue&type=style&index=0&id=0b0a3874&lang=scss&scoped=true"

import exportComponent from "F:\\tubida\\tbd_screen_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b0a3874"]])

export default __exports__